module.exports = __webpack_public_path__ + "img/03_Gruende_iPad_L.ba468291.jpg";